import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type TravelRequestDetailConstructor } from '@webapp/modules/expense/entities/TravelRequestDetail'
import { TravelRequestDetail } from '@webapp/modules/expense/entities/TravelRequestDetail'
import { travelQueryConfig } from '@webapp/modules/expense/query-configs/travel'

interface UseQueryTravelDetailsParams {
  uuid: string
}

interface UseQueryTravelDetailsReturn {
  travel: TravelRequestDetail | undefined
  isLoading: boolean
  error: Nullable<RepoError>
}

export const useQueryTravelDetails = ({
  uuid,
}: UseQueryTravelDetailsParams): UseQueryTravelDetailsReturn => {
  const { data, isLoading, error } = useQuery<
    TravelRequestDetailConstructor,
    RepoError
  >({
    ...travelQueryConfig.detail(uuid),
  })

  const travel = useMemo(
    () => (data ? new TravelRequestDetail(data) : undefined),
    [data]
  )

  return {
    travel,
    isLoading,
    error,
  }
}
